import React from 'react';
import { useState } from 'react';
import { Card, Form, InputGroup, Alert} from 'react-bootstrap';
import { HHIEButton } from './utility/HHIEButton';
import { HHIECard } from './utility/HHIECard';
import { HHIEError } from './utility/HHIEError';
import Loading from './utility/Loading';

export function ForgotPassword() {
    const [email, setEmail] = useState(null);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const validateEmail = (email) => {
        if (email === null) {
            return false;
        }
        if (email === "") {
            return false;
        }
        if (!email.includes("@")) {
            return false;
        }
        if (email.length < 7) {
            return false;
        }
        return true;
    };
    const errorAction = (emailErrorMessage) => {
        setError(true);
        setErrorMessage(emailErrorMessage);
        setLoading(false);
        setEmail(null);
        return;
    };

    const emailUser = async () => {
        setLoading(true);
        let emailcopy = email;
        const emailErrorMessage = "Please enter a valid email. " 
            + emailcopy 
            + " is not an acceptable email address.";
        if (!validateEmail(emailcopy)) {
            errorAction(emailErrorMessage);
            return;
        }
        
        // email user or return false 
        const result = await fetch('api/POCUser/email-user/' + emailcopy)
        .then(async (response) => {
            try {
                const json = await response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message;
                    });
                return json;
            } catch (ex) {
                errorAction("You haven't completed your security questions, please contact the HHIE as we cannot reset your password with this functionality. [" + ex + "]");
                return console.log(ex);
            }
        })
        .catch(ex => {
            console.log(ex);
            errorAction("You haven't completed your security questions, please contact the HHIE as we cannot reset your password with this functionality. Error[" + ex + "]");
        });

        setLoading(false);
        setSuccess(result);
    }
    return (
        <HHIECard>
            <Card.Title>Forgot your password?</Card.Title>
            {loading && <Loading message={"Looking for " + email + " please wait..."}/>}
            {!loading && !success && !error &&
            <Form>
                <Form.Group
                    className="mb-3"
                    controlId="forgottenPwd"
                >
                    <Form.Label>
                        Please enter your email to begin your password recovery.
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="email"
                            placeholder="Email"
                            
                            onChange={(e) => { e.preventDefault(); setEmail(e.target.value); }}
                        />
                        <HHIEButton
                            id="send-mail-btn"
                            title="Send Email"
                            disabled={(email === null || email === "" || email.length < 7 || !email.includes("@") || !email.includes("."))}
                            size="sm"
                            style={{}}
                            onClick={emailUser}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    emailUser();
                                }
                            }}
                        />
                    </InputGroup>
                </Form.Group>
            </Form>
            }
            {error &&
            <HHIEError 
                message={errorMessage}
                onClick={() => {
                    setError(false);
                    setErrorMessage("");}
                }
            />
            }
            {success &&
            <Alert variant="success">
                An email has been sent to {email} with information that will expire soon. 
                Please go into your mailbox and take the necessary action to recover your credentials.
                <hr/>
                If you have not received an email, please check your junk folder, or <Alert.Link href="/login">retry this password reset process.</Alert.Link>
            </Alert>
            }
        </HHIECard>
    );
}
